import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    /* -----
     * MONTHLY REPORT
     * ----- */

    async createReportMonthly({ commit }, data) {
      try {
        return await api.post('/reports/monthly', data)
      } catch (error) {
        throw error
      }
    },

    async getReportMonthly({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/reports/monthly?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateReportMonthly({ commit }, data) {
      try {
        return await api.put(`/reports/monthly/${data.reportId}`, data.report)
      } catch (error) {
        throw error
      }
    },

    async deleteReportMonthly({ commit }, reportId) {
      try {
        return await api.delete(`/reports/monthly/${reportId}`)
      } catch (error) {
        throw error
      }
    },

    async updateReportMonthlyExportTicket({ commit }, data) {
      try {
        return await api.put(
          `/reports/monthly/${data.reportId}/tickets/${data.reportTicketId}/export`,
          data.ticket,
        )
      } catch (error) {
        throw error
      }
    },

    async updateReportMonthlyTimeTicket({ commit }, data) {
      try {
        return await api.put(
          `/reports/monthly/${data.reportId}/tickets/${data.reportTicketId}/time`,
          data.ticket,
        )
      } catch (error) {
        throw error
      }
    },

    /* -----
     * ACCUMULATED REPORT
     * ----- */

    async createReportAccumulated({ commit }, data) {
      try {
        return await api.post('/reports/accumulated', data)
      } catch (error) {
        throw error
      }
    },

    async getReportsAccumulated({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/reports/accumulated?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getReportAccumulated({ commit }, reportId) {
      try {
        const response = await api.get(`/reports/accumulated/${reportId}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async deleteReportAccumulated({ commit }, reportId) {
      try {
        return await api.delete(`/reports/accumulated/${reportId}`)
      } catch (error) {
        throw error
      }
    },

    async updateReportAccumulatedExportTicket({ commit }, data) {
      try {
        return await api.put(
          `/reports/accumulated/${data.reportId}/tickets/${data.reportTicketId}/export`,
          data.ticket,
        )
      } catch (error) {
        throw error
      }
    },

    async updateReportAccumulatedTimeTicket({ commit }, data) {
      try {
        return await api.put(
          `/reports/accumulated/${data.reportId}/tickets/${data.reportTicketId}/time`,
          data.ticket,
        )
      } catch (error) {
        throw error
      }
    },

    /* -----
     * DASHBOARD REPORT
     * ----- */

    async getReportDashboard({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/reports/dashboard?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    /* -----
     * PRODUCTIVITY REPORT
     * ----- */

    async getReportProductivitySummary({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/reports/productivity/summary?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getReportProductivityDetailed({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(
          `/reports/productivity/detailed?${params}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
